import { useRef, useState } from "react";
import { RouteNames } from "routes/routes";
import AppButton from "components/AppButton/AppButton";
import ContainerFlex from "components/ContainerFlex";
import { useAppSelector } from "redux/app/hooks";
import { useHistory } from "react-router";

import * as St from "./styles";

import ReactToPrint from "react-to-print";
import { SecurityPageProps } from "models/security";
import { useLocation } from "react-router-dom";
import assets from "assets";
import PrintPaymentVoucher from "./PrintPaymentVoucher";

const FeedUserPOS: React.FC<SecurityPageProps> = ({
  title,
  description = "",
}) => {
  const [acaoBtn, setAcaoBtn] = useState(false);
  const history = useHistory();
  const { state } = useLocation<any>();

  const componentRef = useRef<HTMLDivElement>(null);

  const { typeFlow } = useAppSelector((state) => state.security);

  const clickBack = () => {
    setAcaoBtn(true);
    history.push(RouteNames.ATENDIMENTO_HOME);
  };

  const loopFeedback = () => {
    if (!acaoBtn) {
      console.log("entrei!!");
      return (
        <St.DivAnimation>
          <St.Icon src={assets.images.sucesso} alt="" />
        </St.DivAnimation>
      );
    }
  };

  return (
    <ContainerFlex>
      <St.TitleH1>{title}</St.TitleH1>
      <ContainerFlex row>
        <ContainerFlex padding={10}>
          <ContainerFlex>
            <ContainerFlex padding={50}>
              <ContainerFlex style={{ paddingLeft: "3rem" }} center>
                <ContainerFlex row>
                  <St.BiggerTextInvoice>{description}</St.BiggerTextInvoice>
                </ContainerFlex>
                {loopFeedback()}
              </ContainerFlex>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex center>
          <ContainerFlex center padding={25}>
            <ContainerFlex
              padding={15}
              color="#fbfbfb"
              width={80}
              height={50}
              maxWidth={100}
              maxHeight={350}
              scroll
              hidden
            >
              <div ref={componentRef}>
                <PrintPaymentVoucher idPagamento={state?.idPagamento} />
              </div>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex center horizontal row space>
        <AppButton
          content="Voltar"
          route={
            typeFlow === "fatura"
              ? RouteNames.HOME
              : RouteNames.ATENDIMENTO_HOME
          }
          outlined={true}
          click={clickBack}
          hidden={false}
        />
        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default FeedUserPOS;
